const glossaryData = [
  {
    term: "Asset Allocation",
    slug: "asset-allocation",
    category: "Portfolio Terms",
    shortDefinition:
      "Asset allocation is how you divide your money across different types of investments, like stocks, bonds, and cash.",
    whyItMatters:
      "Your asset allocation affects your risk level, growth potential, and how your portfolio behaves over time.",
    relatedLinks: [
      { label: "Beginner Portfolio Guide", url: "https://www.youtube.com/watch?v=iTPmW3R6wYU" }
    ]
  },
  {
    term: "Bear Market",
    slug: "bear-market",
    category: "Market Terms",
    shortDefinition:
      "A bear market is a period when stock prices fall significantly and investor sentiment is generally negative.",
    whyItMatters:
      "Bear markets can be uncomfortable, but they are a normal part of investing and important for beginners to understand.",
    relatedLinks: []
  },
  {
    term: "Brokerage Account",
    slug: "brokerage-account",
    category: "Beginner Basics",
    shortDefinition:
      "A brokerage account is an account that lets you buy and sell investments like stocks, ETFs, and mutual funds.",
    whyItMatters:
      "You need a brokerage account before you can actually start investing in the market.",
    relatedLinks: []
  },
  {
    term: "Bull Market",
    slug: "bull-market",
    category: "Market Terms",
    shortDefinition:
      "A bull market is a period when stock prices are rising and investor confidence is generally strong.",
    whyItMatters:
      "Bull markets can make investing feel easy, but beginners still need to understand risk and stay disciplined.",
    relatedLinks: []
  },
  {
    term: "Covered Call ETF",
    slug: "covered-call-etf",
    category: "ETF Terms",
    shortDefinition:
      "A covered call ETF is a fund that holds stocks or stock exposure and sells call options to generate income.",
    whyItMatters:
      "These ETFs can produce high income, but they often trade away some upside growth in exchange for that cash flow.",
    relatedLinks: [
      { label: "Covered Call ETFs Explained", url: "https://www.youtube.com/shorts/pZTVcauq85s" }
    ]
  },
  {
    term: "Correction",
    slug: "correction",
    category: "Market Terms",
    shortDefinition:
      "A market correction is a decline of around 10% from a recent high in a stock or market index.",
    whyItMatters:
      "Corrections happen regularly, and understanding them can help beginners avoid emotional decisions.",
    relatedLinks: []
  },
  {
    term: "Diversification",
    slug: "diversification",
    category: "Beginner Basics",
    shortDefinition:
      "Diversification means spreading your money across different investments instead of putting it all into one stock or asset.",
    whyItMatters:
      "Diversification can help reduce risk by lowering the impact of any one investment performing badly.",
    relatedLinks: [
      { label: "Best ETFs for Beginners", url: "https://www.youtube.com/shorts/KY8ecdMlp2w" }
    ]
  },
  {
    term: "Dividend",
    slug: "dividend",
    category: "Dividend Terms",
    shortDefinition:
      "A dividend is a payment some companies or funds make to investors, usually from profits or income generated by the holdings.",
    whyItMatters:
      "Dividends can provide cash flow and are a big reason many investors focus on income-producing stocks and ETFs.",
    relatedLinks: []
  },
  {
    term: "Dividend Yield",
    slug: "dividend-yield",
    category: "Dividend Terms",
    shortDefinition:
      "Dividend yield shows how much an investment pays in dividends each year compared to its current price, usually as a percentage.",
    whyItMatters:
      "Yield helps income investors compare investments, but a very high yield can sometimes signal added risk.",
    relatedLinks: []
  },
  {
    term: "Dollar-Cost Averaging",
    slug: "dollar-cost-averaging",
    category: "Strategy Terms",
    shortDefinition:
      "Dollar-cost averaging means investing a set amount of money at regular intervals instead of trying to time the market.",
    whyItMatters:
      "This strategy can help beginners stay consistent and reduce the pressure of deciding when to invest.",
    relatedLinks: []
  },
  {
    term: "EPS",
    slug: "eps",
    category: "Valuation Terms",
    shortDefinition:
      "EPS stands for earnings per share, which measures how much profit a company earned for each outstanding share.",
    whyItMatters:
      "EPS is a commonly used metric when investors look at profitability and valuation.",
    relatedLinks: []
  },
  {
    term: "ETF",
    slug: "etf",
    category: "ETF Terms",
    shortDefinition:
      "An ETF, or exchange-traded fund, is a basket of investments that trades on the stock market like a stock.",
    whyItMatters:
      "ETFs help beginners diversify more easily because one fund can hold many different investments.",
    relatedLinks: [
      { label: "What Is an ETF?", url: "https://www.youtube.com/watch?v=PclecxNlBHE" }
    ]
  },
  {
    term: "Expense Ratio",
    slug: "expense-ratio",
    category: "ETF Terms",
    shortDefinition:
      "The expense ratio is the annual fee a fund charges investors, shown as a percentage of the money invested.",
    whyItMatters:
      "Lower fees can help investors keep more of their returns over long periods of time.",
    relatedLinks: []
  },
  {
    term: "Ex-Dividend Date",
    slug: "ex-dividend-date",
    category: "Dividend Terms",
    shortDefinition:
      "The ex-dividend date is the cutoff date investors must own a stock or fund by in order to receive the next dividend payment.",
    whyItMatters:
      "Beginners often confuse payout timing, and this date is one of the most important dividend terms to understand.",
    relatedLinks: []
  },
  {
    term: "Index Fund",
    slug: "index-fund",
    category: "ETF Terms",
    shortDefinition:
      "An index fund is a fund that aims to track the performance of a specific market index, like the S&P 500.",
    whyItMatters:
      "Index funds are popular with beginners because they offer broad exposure and a simple investing approach.",
    relatedLinks: [
      { label: "What Is a Stock Index?", url: "https://www.youtube.com/shorts/3elQaogf4NQ" }
    ]
  },
  {
    term: "Market Cap",
    slug: "market-cap",
    category: "Market Terms",
    shortDefinition:
      "Market cap, short for market capitalization, is the total value of a company’s outstanding shares.",
    whyItMatters:
      "Market cap helps investors understand the size of a company, such as large-cap, mid-cap, or small-cap.",
    relatedLinks: []
  },
  {
    term: "Mutual Fund",
    slug: "mutual-fund",
    category: "Beginner Basics",
    shortDefinition:
      "A mutual fund is a pooled investment fund that collects money from many investors and invests it according to a strategy.",
    whyItMatters:
      "Mutual funds are common retirement and long-term investing vehicles, though they work a little differently than ETFs.",
    relatedLinks: []
  },
  {
    term: "NAV",
    slug: "nav",
    category: "ETF Terms",
    shortDefinition:
      "NAV stands for net asset value, which is the value of a fund’s underlying holdings minus liabilities, usually calculated per share.",
    whyItMatters:
      "NAV can help investors understand how a fund’s value is measured, especially when comparing certain income strategies.",
    relatedLinks: []
  },
  {
    term: "P/E Ratio",
    slug: "pe-ratio",
    category: "Valuation Terms",
    shortDefinition:
      "The P/E ratio compares a company’s stock price to its earnings per share.",
    whyItMatters:
      "It is one of the most common valuation tools investors use to judge whether a stock looks expensive or cheap.",
    relatedLinks: []
  },
  {
    term: "Portfolio",
    slug: "portfolio",
    category: "Portfolio Terms",
    shortDefinition:
      "A portfolio is the collection of investments you own, such as stocks, ETFs, mutual funds, or other assets.",
    whyItMatters:
      "Understanding your portfolio helps you think more clearly about risk, diversification, and long-term goals.",
    relatedLinks: []
  },
  {
    term: "Rebalancing",
    slug: "rebalancing",
    category: "Portfolio Terms",
    shortDefinition:
      "Rebalancing means adjusting your portfolio back to your target percentages after some investments grow faster or fall more than others.",
    whyItMatters:
      "Rebalancing helps keep your portfolio aligned with your original strategy and risk level.",
    relatedLinks: []
  },
  {
    term: "Risk Tolerance",
    slug: "risk-tolerance",
    category: "Strategy Terms",
    shortDefinition:
      "Risk tolerance is how much volatility or loss you are emotionally and financially able to handle as an investor.",
    whyItMatters:
      "Knowing your risk tolerance can help you choose investments you are more likely to stick with long term.",
    relatedLinks: []
  },
  {
    term: "S&P 500",
    slug: "sp500",
    category: "Market Terms",
    shortDefinition:
      "The S&P 500 is a stock market index made up of 500 large U.S. companies.",
    whyItMatters:
      "It is one of the most widely followed benchmarks in investing and is often used in beginner portfolios.",
    relatedLinks: [
      { label: "SPY and the S&P 500 Explained", url: "https://www.youtube.com/watch?v=bNeNf4YIXBw&utm_source=website&utm_medium=learn_page&utm_campaign=beginner" }
    ]
  },
  {
    term: "Share",
    slug: "share",
    category: "Beginner Basics",
    shortDefinition:
      "A share is a unit of ownership in a company or fund.",
    whyItMatters:
      "When you buy shares, you own a piece of that investment.",
    relatedLinks: []
  },
  {
    term: "Stock",
    slug: "stock",
    category: "Beginner Basics",
    shortDefinition:
      "A stock represents ownership in a company.",
    whyItMatters:
      "Stocks are one of the main building blocks of investing and are often the first asset beginners learn about.",
    relatedLinks: []
  },
  {
    term: "Ticker Symbol",
    slug: "ticker-symbol",
    category: "Beginner Basics",
    shortDefinition:
      "A ticker symbol is the short group of letters used to identify a stock, ETF, or other traded investment.",
    whyItMatters:
      "Ticker symbols are how investors quickly identify investments, like AAPL, SPY, or SCHD.",
    relatedLinks: []
  },
  {
    term: "Time Horizon",
    slug: "time-horizon",
    category: "Strategy Terms",
    shortDefinition:
      "Your time horizon is how long you expect to keep your money invested before you need it.",
    whyItMatters:
      "A longer time horizon usually gives investors more ability to take on short-term volatility.",
    relatedLinks: []
  },
  {
    term: "Volatility",
    slug: "volatility",
    category: "Market Terms",
    shortDefinition:
      "Volatility refers to how much the price of an investment moves up and down over time.",
    whyItMatters:
      "Higher volatility can mean more risk, especially for beginners who are not used to market swings.",
    relatedLinks: []
  },
  {
    term: "Yield",
    slug: "yield",
    category: "Dividend Terms",
    shortDefinition:
      "Yield is the income an investment produces compared to its price, usually shown as a percentage.",
    whyItMatters:
      "Yield is useful for income-focused investors, but it should be looked at alongside quality and sustainability.",
    relatedLinks: []
  }
];

export default glossaryData;